var $de304da575c0e64d$exports = {};
$de304da575c0e64d$exports = {
    "info": `Informacje`,
    "negative": `B\u{142}\u{105}d`,
    "positive": `Powodzenie`
};


export {$de304da575c0e64d$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
